module.exports = __webpack_public_path__ + "img/Yosemite National Park depth5.18a0097d.jpg";